import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import { blue } from '@mui/material/colors';
import { getRoleUser } from '../../../utils';

function ModalUsersConversation({ onClose, open, users }) {
  const handleClose = () => {
    onClose();
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Start a conversation</DialogTitle>
      <List sx={{ pt: 0, width: 400 }}>
        {users.map((user) => (
          <ListItem button onClick={() => handleListItemClick(user)} key={user.id}>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                <PersonIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={`${user.name} ${user.last_name}`}
              secondary={getRoleUser(user?.role?.id)}
            />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}

ModalUsersConversation.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  users: PropTypes.any.isRequired,
};

export default ModalUsersConversation;
